<h2 i18n="section.signInMethods.form.changePassword.title">Enter your new password</h2>

<form [formGroup]="form" (ngSubmit)="onSubmit()" style="display:grid; gap:12px; max-width:420px;">
  <mat-form-field>
    <mat-label i18n="@@common.newPassword">New password</mat-label>
    <input matInput type="password" [formControlName]="ChangePasswordForm.FIELD_PASSWORD">
    <mat-error *ngIf="form.get(ChangePasswordForm.FIELD_PASSWORD)?.hasError('required')" i18n="@@common.validation.required">Required</mat-error>
    <mat-error *ngIf="form.get(ChangePasswordForm.FIELD_PASSWORD)?.hasError('minlength')"
               i18n="@@common.validation.minLength">It must be at least {{passwordMinLength}} characters long.
    </mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label i18n="@@common.newPasswordConfirmation">New password (just in case)</mat-label>
    <input matInput type="password" [formControlName]="ChangePasswordForm.FIELD_CONFIRM">
    <mat-error *ngIf="form.get(ChangePasswordForm.FIELD_CONFIRM)?.hasError('required')" i18n="@@common.validation.required">Required</mat-error>
    <mat-error *ngIf="form.get(ChangePasswordForm.FIELD_CONFIRM)?.hasError('mismatch')"
               i18n="@@common.validation.passwordMismatch">Passwords do not match</mat-error>
  </mat-form-field>

  <div style="display:flex; gap:8px; align-items:center; justify-content: right;">
    <button mat-stroked-button
            type="button"
            (click)="onCancel()"
            [disabled]="submitting">
      <ng-container i18n="@@common.action.cancel">Cancel</ng-container>
    </button>

    <button mat-flat-button
            color="primary"
            [disabled]="form.invalid || submitting">
      <ng-container *ngIf="!submitting" i18n="@@common.action.change">Change</ng-container>
      <ng-container *ngIf="submitting" i18n="@@common.action.changing">Changing...</ng-container>
    </button>
  </div>
</form>
